const paperLangs = {
  paperList: {
    title: "Danh sách loại giấy",
  },
  paperAdd: {
    title: "Thêm loại giấy",
  },
  error: {
    paperList: "lấy danh sách loại giấy lỗi",
    paperAdd: "Thêm loại giấy bị lỗi",
    paperUpdate: "Cập nhật loại giấy lỗi",
    paperDelete: "Xoá loại giấy lỗi",
  },
  success: {
    paperAdd: "Thêm loại giấy thành công",
    paperUpdate: "Cập nhật loại giấy thành công",
    paperDelete: "Xoá loại giấy thành công",
  },
};

export default paperLangs;
